import millify from "millify";
import { Collapse, Row, Col, Typography, Avatar } from "antd";
//import HTMLReactParser from "html-react-parser";
import React from "react";
import { useGetExchangesQuery } from "../services/cryptoCoinsApi";
import Loader from "./Loader";
const { Text, Title } = Typography;
const { Panel } = Collapse;
export default function Exchanges() {
  const { data, isFetching } = useGetExchangesQuery();
  const exchangesList = data?.data?.exchanges;

  if (isFetching) return <Loader />;
  return (
    <>
      <Title level={2}>Exchange Index</Title>
      <Row>
        <Col span={6}>Exchanges</Col>
        <Col span={6}>Price(USD)</Col>
        <Col span={6}>Markets</Col>
        <Col span={6}>Coin Url</Col>
      </Row>
      <Row>
        {exchangesList.map((exchange) => (
          <Col span={24}>
            <Collapse>
              <Panel
                key={exchange.uuid}
                showArrow={false}
                header={
                  <Row key={exchange.uuid}>
                    <Col span={6}>
                      <Text>
                        <strong>{exchange.rank}.</strong>
                      </Text>
                      <Avatar
                        className="exchange-image"
                        src={exchange.iconUrl}
                      />
                      <Text>
                        <strong>{exchange.name}</strong>
                      </Text>
                    </Col>
                    <Col span={6}>${millify(exchange.price)}</Col>
                    <Col span={6}>{millify(exchange.numberOfMarkets)}</Col>
                    <Col span={6}>
                      <a
                        href={exchange.coinrankingUrl}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {exchange.name}
                      </a>
                    </Col>
                  </Row>
                }
              >
                <a
                  href={exchange.coinrankingUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {exchange.coinrankingUrl}
                </a>
              </Panel>
            </Collapse>
          </Col>
        ))}
      </Row>
    </>
  );
}
